import { PropTypes } from 'prop-types';
import React from 'react';

import { Flex } from '../../grid';
import { P } from '../../typography/new';
import { ModalHeaderButton } from '../../modal-header-button';

const OrderSettingsModalHeader = ({ title, handleBack, handleClose }) => (
  <Flex
    alignItems="center"
    justifyContent="space-between"
    px="16px"
    py="16px"
    borderBottom="1px solid"
    borderColor="warmWhite4"
    mb="32px"
  >
    <Flex width="40px">
      {handleBack && <ModalHeaderButton onClick={handleBack} icon="chevronLeft" ariaLabel="Back" />}
    </Flex>
    <P variant="medium-bold" textAlign="center" flex={1}>
      {title}
    </P>
    <Flex width="40px" justifyContent="flex-end">
      <ModalHeaderButton onClick={handleClose} ariaLabel="Close" />
    </Flex>
  </Flex>
);

OrderSettingsModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  handleBack: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
};

OrderSettingsModalHeader.defaultProps = {
  handleBack: null,
};

export { OrderSettingsModalHeader };
